import { gql } from '__generated__';

export default gql(`
  mutation SendMessage($input: SendMessageInput!) {
    sendMessage(input: $input) {
      id
      sendable
      remaining_count
      last_sent_at
      scheduled_at
    }
  }
`);
